import Raven from 'raven-js';

const log = (ex, context) => {
  Raven.captureException(ex, { extra: context });
  if ('console' in window && console.error) {
    /* eslint no-console:0 */
    console.error(ex);
  }
};

export default log;



// WEBPACK FOOTER //
// ./src/util/ErrorUtils.js